import React from 'react';
import { Link } from 'react-router-dom';
import './LegalPage.css';

function Impressum() {
  return (
    <div className="legal-page">
      <nav className="legal-nav">
        <div className="nav-container">
          <Link to="/" className="nav-logo">
            <img src="/images/logo.png" alt="F&F AI Automation" className="nav-logo-img" />
          </Link>
          <Link to="/" className="back-link">Zurück zur Startseite</Link>
        </div>
      </nav>

      <main className="legal-content">
        <div className="legal-container">
          <h1>Impressum</h1>

          <div className="legal-section">
            <p><strong>F&amp;F AI Automation Services &amp; Products UG (haftungsbeschränkt)</strong></p>
          </div>

          <div className="legal-section">
            <h2>Ladungsfähige Geschäftsadresse</h2>
            <p>Wannenstr. 14</p>
            <p>74842 Billigheim, Baden-Württemberg, Deutschland</p>
          </div>

          <div className="legal-section">
            <h2>Vertreten durch</h2>
            <p>Robin Fichter, Gesellschafter und Geschäftsführer</p>
            <p>Gabriel Frank, Gesellschafter</p>
          </div>

          <div className="legal-section">
            <h2>Kontakt</h2>
            <p>E-Mail: <a href="mailto:info@ff-ai-automation.de">info@ff-ai-automation.de</a></p>
            <p>Website: <a href="https://www.ff-ai-automation.de" target="_blank" rel="noopener noreferrer">www.ff-ai-automation.de</a></p>
          </div>

          <div className="legal-section">
            <h2>Registereintrag</h2>
            <p>Amtsgericht Mannheim</p>
            <p>Registernummer: HRB 757313</p>
          </div>

          <div className="legal-section">
            <h2>Umsatzsteuer- und Wirtschafts-Identifikationsnummer</h2>
            <p>DE460275116</p>
          </div>
        </div>
      </main>

      <footer className="legal-footer">
        <p>© {new Date().getFullYear()} F&amp;F AI Automation Services &amp; Products UG (haftungsbeschränkt)</p>
      </footer>
    </div>
  );
}

export default Impressum;
